// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"x4-z","displaySixCardTiles":"y4-z"};